import React from "react";
import {Navigate, Outlet, RouteProps} from "react-router-dom";
import {observer} from "mobx-react";
import {Bindings} from "data/constants/bindings";
import {useViewController} from "data/services/locator";
import {ISecondStepSsoRouteController} from "./second_step_sso_route.controller";
import {useLocation} from 'react-router';

export const SecondStepSsoRoute: React.FC<RouteProps> = observer(() => {
	const location = useLocation();
	const {isShowRegistrationPage, isTermsAccepted, user} = useViewController<ISecondStepSsoRouteController>(
		Bindings.SecondStepSsoRouteController
	);

	if (isShowRegistrationPage && location.pathname !== '/registration') {
		return <Navigate to="/registration" replace />;
	}

	if(user && !isTermsAccepted ) {
		return <Navigate to="/registration/terms" replace/>;
	}

	return <Outlet />;
});
